import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SystemTypeState {
  id: string;
  name: string;
  operations: string;
  isActive: boolean;
  props: {
    [key: string]: any;
  };
}

const initialState: SystemTypeState = {
  id: '',
  name: '',
  operations: '',
  isActive: false,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const systemTypeSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setSystem: (state, action: PayloadAction<Partial<SystemTypeState>>) => {
      return { ...state, ...action.payload };
    },

    resetSystemType: (_state, action: PayloadAction<Partial<SystemTypeState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: SystemTypeState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setSystem, resetSystemType, updateField, updateProps } = systemTypeSlice.actions;

export default systemTypeSlice.reducer;
